<script>
import { mapActions } from "vuex";
import InputGroup from "@/components/_Shared/InputGroup";

export default {
  components: {
    InputGroup
  },
  data() {
    return {
      clients: [],
      query: null,
      selected: null
    };
  },
  methods: {
    ...mapActions("clients", ["searchByName"]),
    async search(q) {
      try {
        this.clients = await this.searchByName(q);
      } catch (e) {
        this.$toast.error(e);
      }
    },
    select(val) {
      this.selected = val;
      this.query = val.attributes.first_name + " " + val.attributes.last_name;
      this.clients = [];
    },
    clearSelected() {
      this.selected = null;
      this.query = null;
    }
  }
};
</script>

<template>
  <div class="section">
    <div class="section-title">
      AGENDE UMA LIMPEZA
      <hr />
    </div>

    <div class="section-body">
      <!-- <div v-if="selected" class="response">
        <div class="selected">{{selected.attributes.first_name+' '+selected.attributes.last_name}}</div>
        <div class="clear" @click="clearSelected()">x</div>
      </div> -->

      <div class="form-group">
        <div class="input-group">
          <input
            :disabled="selected"
            id="search"
            type="text"
            v-model="query"
            @keyup="search(query)"
          />
          <label for="search">cliente</label>
        </div>
        <div v-show="selected" class="clear" @click="clearSelected()">x</div>
      </div>

      <ul>
        <li
          v-for="(client, index) in clients"
          :key="index"
          @click="select(client)"
        >
          {{ client.attributes.first_name + " " + client.attributes.last_name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.section {
  display: flex;
  justify-content: center;
}

.form-group {
  width: 400px;
}

.clear {
  background: red;
  color: white;
  cursor: pointer;
  border-radius: 4px;
  height: 20px;
  padding: 5px 10px;
}

ul {
  /* position: absolute; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0 5px;
  border: 1px solid #eee;
  border-radius: 0 0 4px 4px;
}

ul li {
  width: calc(100% - 20px);
  padding: 10px 10px;
  cursor: pointer;
  font-size: 14px;
  background-color: #fff;
}

ul li:hover {
  background-color: #f9f9f9;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/OrdersAndSubscriptions/Client.vue